import { createClient } from '@supabase/supabase-js'

const url = 'https://oweklqzvhvkxjozbpbmh.supabase.co'
const key = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im93ZWtscXp2aHZreGpvemJwYm1oIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NjUyNDkwOTAsImV4cCI6MTk4MDgyNTA5MH0._G6f2Q8TCyW9pIQmNWYgJ8sN7JhV661augFwikQA3uI'
export const supabase = createClient(url, key)